export default __webpack_public_path__ + "static/media/logo.122b1f0a.svg";